import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { GoalAnalysisService } from '../../services/goal-analysis.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import * as Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
import { Utils } from '../../../utils/utils';
addMore(Highcharts)

@Component({
  selector: 'gp-asset-projection',
  templateUrl: './asset-projection.component.html',
  styleUrls: ['./asset-projection.component.scss']
})
export class AssetProjectionComponent implements OnInit, OnDestroy {

  protected _storeDataSubscription: Subscription;
  protected _uiStateSubscription: Subscription;

  Highcharts: typeof Highcharts = Highcharts;
  options: Highcharts.Options;
  private chart: Highcharts.Chart;


  dataSource;
  displayedColumns: string[] = ['yr', 'portBeginBal', 'totIncome', 'portInc', 'totExpense', 'totTax', 'portTaxes', 'totSavings', 'netCashFlow', 'portEndBal'];
  isDataAvailable = false;
  
  constructor(private dataService: DataService,
      private uiStateService: UIStateService,  
      private goalAnalysisService: GoalAnalysisService,
      private appMonitoringService: AppMonitoringService) {    
  }

  ngOnInit(): void {
    //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "AssetProjectionComponent-ngOnInit", true);
    this.dataService.getPlanAnalysis();        
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
    this._uiStateSubscription =  this.uiStateService.subscribe((uiState: fromModel.IUIState) => this.populateUIContext(uiState));     
  }

  private populateAppData(appData: fromModel.IAppData){
    this.dataSource = null;
    this.isDataAvailable = false;
    if(appData && (appData.action===fromModel.DATA_ACTION.UPDATESETTINGS)){                
      this.dataService.getGoalSummary();      
      this.dataService.getPlanAnalysis();      
    } else {
      if(appData && appData.action!==fromModel.DATA_ACTION.NONE){      
        let projection = this.dataService.getPlanAnalysisProjection();
        if(projection!== null){
          if(projection.Error){
            this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "AssetProjectionComponent-populateAppData - Error", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.analyticErrorMsg});
          } else {
            this.dataSource =  projection;
            this.setChartOptionsData();
            this.isDataAvailable = true;
            this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "AssetProjectionComponent-populateAppData", false);
          }
        } else {
          // this.isDataAvailable = false;
          // this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "AssetProjectionComponent-populateAppData", false);        
        }
      }
    }
  }


  populateUIContext(uiState: fromModel.IUIState){     
    if(uiState && uiState.action === fromModel.UI_STATE_ACTION.REFRESH){
      if(uiState.Refresh){
        this.resizeChart();
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.REFRESH, "IncomeComponent-populateUIContext", false);        
      }
      
    }
  }

  private setChartOptionsData(){
    this.options = {
      chart: {
        type: 'spline',    
        //height: 500,        
        //width: 700,
        style: {
          fontSize: '18'
        }                           
      },
      title: {
        text: ''
      },
       credits: {
        enabled: false
      },
      subtitle: {
        text: ''
      },
      xAxis: {        
        title: {              
            //text: 'Years',
            style: {
              fontSize: '16'
            }
        },
        labels: {
          style: {            
              fontSize:'14'
          }
        },
        crosshair: {
          width: 1,
          zIndex: 11,
          dashStyle: 'Dash',
          color: 'gray'
        },
        type: 'datetime',
        startOnTick: true,
        tickInterval: 1000 * 60 * 60 * 24 * 1825,  
        // endOnTick: true,
        // showLastLabel: true,
        // labels: {
        //   enabled: false,
        //   style: {                
        //     fontSize: '16'
        //   }
        // },
        // tickInterval: 12,
        allowDecimals: false,
        //min: 0
        tickWidth: 0,
        plotLines: [],
      },
      yAxis: {
        title: {
            text: 'Portfolio Value ($)',
            style: {
              fontSize: '16'
            }
        },          
        labels: {
          style: {                
              fontSize: '16'
          }
        },
        crosshair: {
          width: 1,
          zIndex: 11,
          dashStyle: 'Dash',
          color: 'gray'
        },
        lineWidth: 0,
        //tickInterval: 2,
        allowDecimals: false,
        //min: 0          
      },
      legend: {
        enabled: true, 
        itemStyle:{
          fontSize: '14'
        }      
      },
      plotOptions: {
        // series: {
        //   pointStart: 2010
        // }

        series: {
          dataLabels: {
              enabled: true,
              style: {
                fontSize: '14'
              },
              formatter: function(){
                  var isLast = false;
                  if(this.series.type === 'spline' && this.point.x === this.series.data[this.series.data.length -1].x && this.point.y === this.series.data[this.series.data.length -1].y) isLast = true;
                  return isLast ? '<b>$' + Highcharts.numberFormat(this.y,0,'.',',') + '</b>' : '';
              }
          },
          marker: {
            enabled: false
         }
        }
        
      },  
      tooltip: {
        shared:true,
        useHTML: true,
        style:{
          color: '#4F528C', 
          fontSize: '14',
          fontFamily: 'Avenir',
          fontWeight: 'bold'
        },
        formatter: function(){
          //console.log(this.points);
          var formatStr = "";          
          if(this.points && this.points.length>0){
            formatStr += '<div class="font16">' + Highcharts.dateFormat('%Y',this.points[0].x) + '</div>';
            var ageSeries = this.points.find(point=>point.series.name === fromModel.CHARTSERIESNAME.Age);
            if(ageSeries){
              var data = ageSeries.series.data.find(data=>data.x === ageSeries.x);
              if(data){
                formatStr += '<span class="font14 pClient">' + data['pName'] + ': <span class="font12">age</span> ' + data['pAge'] + '</span>'; 
                if(data['sDisplayName']){
                  formatStr += ' | <span class="font14 sClient">' + data['sName'] + ': <span class="font12">age</span> ' + data['sAge'] + '</span>'; 
                } 
                formatStr += '</br></br>';              
              }
            }                      
            formatStr +=  '<table style="width: 100%">';
            for (var i = 0; i < this.points.length; i++) {
              var point = this.points[i];
              if( point.series.name!==fromModel.CHARTSERIESNAME.Age && point.series.name!==fromModel.CHARTSERIESNAME.Range){        
                  formatStr += '<tr>';
                  formatStr += '<td>';
                  //formatStr += '<span class="font18 m-r5" style="color:' + point.color + '">●</span>';                  
                  formatStr += '<span class="m-r5"><svg width="10" height="10"><circle cx="5" cy="5" r="5" fill="' + point.color + '" /></svg></span>';                
                  formatStr += point.series.name;
                  formatStr += '</td>';
                  formatStr += '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td>'; 
                  formatStr += '</tr>';
              }
            }
            formatStr += '</table>';               
          }
          return formatStr;
        },
       },      
       series: []     
    }; 

    let { series } = this.options;
    series = this.getChartData(series);
    this.options = {...this.options, series};   

    let { xAxis } = this.options;
    xAxis = this.getChartXPlotLine(xAxis);
    this.options = {...this.options, xAxis}; 
  }

  private getChartData(series){
    let data;
    let lowProjections = [];
    let mediumProjections = [];
    let highProjections = [];
    let month;
    let day;
    let year;
    let displayDate;
    let amountLow;
    let amountMedium;
    let amountHigh;

    let band = [];
    let banData;

    this.dataSource.forEach((projection, i) => {
      
      if(i===0){
        month = 0;
        day = 1;
        year = projection.year + 1;
      } else if(i===1){
        month = 5;
        day = 1;
        year = projection.year;
      } else {
        month = 0;
        day = 1;
        year = projection.year;
      }
      
      displayDate = Date.UTC(year, month, day);              
      
      amountLow = parseFloat((projection.amountlow).toFixed(2));
      data = {x: displayDate , y:amountLow};    
      lowProjections.push(data);

      amountMedium  = parseFloat((projection.amountmedium).toFixed(2));
      data = {x: displayDate , y:amountMedium};
      mediumProjections.push(data);

      amountHigh = parseFloat((projection.amounthigh).toFixed(2));
      data = {x: displayDate , y:amountHigh};    
      highProjections.push(data);

      banData = [displayDate, amountHigh, amountLow];
      band.push(banData);

    });
    //dashStyle: 'ShortDash'
    series.push({name: fromModel.CHARTSERIESNAME.Range, showInLegend: false, type: 'areasplinerange', data: band, fillColor: '#dfeefc', color: '#7cb5ec'});
    series.push({name: fromModel.CHARTSERIESNAME.Low, data: lowProjections, lineWidth: 2, color: 'lightblue'});
    series.push({name: fromModel.CHARTSERIESNAME.Medium, data: mediumProjections, lineWidth: 2, color: 'blue'});
    series.push({name: fromModel.CHARTSERIESNAME.High, data: highProjections, lineWidth: 2, color: 'lightblue'});

    series.push(this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.AGE}).series[0]);
    
    return series;
  }

  private getChartXPlotLine(xAxis) {

    let lastProjPoint;
    let tempDate;
    let month;
    let day;
    let year;
    let displayDate;

    let primaryClient = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary);
    month = 0;
    day = 1;
    year = Utils.getYearByAge(primaryClient.age, primaryClient.retAge);
    displayDate = Date.UTC(year, month, day);
    xAxis.plotLines.push({ color: '#a3a2a0', width: 2, dashStyle: "Dash", zIndex: 5, value: displayDate, label: {text: 'Retirement', align: 'top',  y: 0}});     

    

    
    return xAxis;
  }

  @HostListener('window:resize', ['$event'])
  onResize(){
    if(this.chart) {
      this.chart.reflow();
      //this.chart.setSize(500,500, false);   
    }
  }

  resizeChart(){
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 200);
  }

  public chartCallBack = (chart: Highcharts.Chart) => {
    this.chart =  chart;
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 300);
  }
  

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }  
    if(this._uiStateSubscription && this._uiStateSubscription !== null){
      this._uiStateSubscription.unsubscribe();    
    }      

  }

}


// formatter: function(){
//   var formatStr = "";
//   for (var i = 0; i < this.points.length; i++) {
//     var point = this.points[i];

//     if(i===0)
//     {
//       formatStr = "<b>" + Highcharts.dateFormat('%Y',point.x) + "</b><br/>";
//       //formatStr = "<b>" + Highcharts.dateFormat('%b %e, %Y',point.x) + "</b><br/>";
//     }

//     if(point.series.name!=='Range'){
  
//     formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//   }
//   }
//   return formatStr;
// },